import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

export interface UrlDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
  onSave: (url: string) => void;
  title?: string;
}

export const UrlDialog: React.FC<UrlDialogProps> = ({
  open,
  onClose,
  url: initialUrl,
  onSave,
  title = 'Edit URL'
}) => {
  const [url, setUrl] = useState(initialUrl);

  useEffect(() => {
    setUrl(initialUrl);
  }, [initialUrl]);

  const handleSave = () => {
    onSave(url);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '90vw',
          overflowX: 'hidden',
          '& .MuiDialogContent-root': {
            width: '100%',
            padding: '24px',
            paddingTop: '12px',
            overflowX: 'hidden'
          },
          '& .MuiDialogTitle-root': {
            padding: '24px',
            paddingBottom: '12px'
          },
          '& .MuiDialogActions-root': {
            padding: '16px 24px'
          }
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          type="url"
          fullWidth
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSave();
            }
          }}
          sx={{
            width: '90%',
            display: 'block',
            margin: '0 auto',
            '& .MuiInputBase-input': {
              fontSize: '1rem',
              fontFamily: 'monospace',
              padding: '12px'
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                top: 0
              }
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 